module.exports = __webpack_public_path__ + "static/media/cementTruck_blue.5a43c277.svg";